import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import type { IncidentStatusLogDto } from '../../features/variance-tracker/components/variance-supporting-data/models/incident-status-log.model';
import type { UpdateIncidentStatusResponse } from '../../features/variance-tracker/components/variance-supporting-data/models/incident-status-log.model';

export interface IncidentStatusClient {
  patchIncidentStatus(
    incidentId: number,
    organizationId: number,
    statusApiValue: string
  ): Observable<UpdateIncidentStatusResponse>;

  getStatusLogs(incidentId: number, organizationId: number): Observable<readonly IncidentStatusLogDto[]>;
}

export const INCIDENT_STATUS_CLIENT = new InjectionToken<IncidentStatusClient>('INCIDENT_STATUS_CLIENT');
